import React, { useEffect, useState } from "react";
import { Form, Row, Col, InputGroup, FormText, Card } from "react-bootstrap";
import {
  IconBuilding,
  IconLabel,
  IconArticle,
  IconUser,
  IconMail,
  IconPhone,
  IconDeviceMobile,
  IconPrinter,
  IconInvoice,
  IconTruck,
  IconFileText,
} from "@tabler/icons-react";
import { useFormContext } from "react-hook-form";
import Notes from "../../components/Notes/Notes";
import { useParams } from "react-router-dom";
function ContactDetailsForm({status}) {



  const { rfq_id } = useParams();

  // const {
  //   register,
  //   getValues,
  //   setValue,
  //   watch,
  //   formState: { errors },
  // } = useFormContext();

  // const StatusIs = watch("status");
  // useEffect(() => {
  //   // if (!StatusIs) {
  //   //   setValue("status", "DRAFT");
  //   // }
  //   const currentNotes = getValues("Notes") || [];
  //   if (currentNotes.length === 0 || !currentNotes[0]?.type) {
  //     setValue("Notes.0.type", "GEN");
  //   }
  //   if (currentNotes.length === 1 || !currentNotes[1]?.type) {
  //     setValue("Notes.1.type", "SALE");
  //   }
  //   if (currentNotes.length === 2 || !currentNotes[2]?.type) {
  //     setValue("Notes.2.type", "BS");
  //   }
  //   if (currentNotes.length === 3 || !currentNotes[3]?.type) {
  //     setValue("Notes.3.type", "CO");
  //   }
  //   if (currentNotes.length === 4 || !currentNotes[4]?.type) {
  //     setValue("Notes.4.type", "POD");
  //   }
  // }, [setValue, getValues]);

  return (
    <>
      <Notes module_type={"RFQ"}  module_id={rfq_id} status={status}/>
      {/* <Row className="mb-3">
        <Col md={4}>
          <Card className="note_card mb-4">
            <Card.Header>General</Card.Header>
            <Card.Body className="pb-0">
              <Card.Text>
                <Form.Control
                  {...register("Notes.0.description")}
                  as="textarea"
                  placeholder="Enter Notes..."
                  style={{
                    height: "auto",
                    minHeight: "80px",
                    resize: "none",
                  }}
                  onInput={(e) => {
                    e.target.style.height = "auto"; // Reset height to auto
                    e.target.style.height = `${e.target.scrollHeight}px`; // Set height to scrollHeight to expand
                  }}
                />
                {errors.Notes && errors.Notes[0]?.description && (
                  <span className="text-danger">
                    {errors.Notes[0]?.description.message}
                  </span>
                )}
              </Card.Text>
            </Card.Body>
            <Card.Footer className="d-flex gap-3 border-0">
           
            </Card.Footer>
          </Card>
        </Col>

        <Col md={4}>
          <Card className="note_card mb-4">
            <Card.Header>Sales</Card.Header>
            <Card.Body className="pb-0">
              <Card.Text>
                <Form.Control
                  {...register("Notes.1.description")}
                  as="textarea"
                  placeholder="Enter Notes..."
                  style={{
                    height: "auto",
                    minHeight: "80px",
                    resize: "none",
                  }}
                  onInput={(e) => {
                    e.target.style.height = "auto"; // Reset height to auto
                    e.target.style.height = `${e.target.scrollHeight}px`; // Set height to scrollHeight to expand
                  }}
                />
                {errors.Notes?.[1]?.description && (
                  <span className="text-danger">
                    {errors.Notes[1]?.description.message}
                  </span>
                )}
              </Card.Text>
            </Card.Body>
            <Card.Footer className="d-flex gap-3 border-0">
            
            </Card.Footer>
          </Card>
        </Col>

        <Col md={4}>
          <Card className="note_card mb-4">
            <Card.Header>Billing & Shipping</Card.Header>
            <Card.Body className="pb-0">
              <Card.Text>
                <Form.Control
                  {...register("Notes.2.description")}
                  as="textarea"
                  placeholder="Enter Notes..."
                  style={{
                    height: "auto",
                    minHeight: "80px",
                    resize: "none",
                  }}
                  onInput={(e) => {
                    e.target.style.height = "auto"; // Reset height to auto
                    e.target.style.height = `${e.target.scrollHeight}px`; // Set height to scrollHeight to expand
                  }}
                />
                {errors.Notes?.[2]?.description && (
                  <span className="text-danger">
                    {errors.Notes?.[2]?.description.message}
                  </span>
                )}
              </Card.Text>
            </Card.Body>
            <Card.Footer className="d-flex gap-3 border-0">
             
            </Card.Footer>
          </Card>
        </Col>

        <Col md={4}>
          <Card className="note_card mb-4">
            <Card.Header>Contracting Officer</Card.Header>
            <Card.Body className="pb-0">
              <Card.Text>
                <Form.Control
                  {...register("Notes.3.description")}
                  as="textarea"
                  placeholder="Enter Notes..."
                  style={{
                    height: "auto",
                    minHeight: "80px",
                    resize: "none",
                  }}
                  onInput={(e) => {
                    e.target.style.height = "auto"; // Reset height to auto
                    e.target.style.height = `${e.target.scrollHeight}px`; // Set height to scrollHeight to expand
                  }}
                />
                {errors.Notes?.[3]?.description && (
                  <span className="text-danger">
                    {errors.Notes?.[3]?.description.message}
                  </span>
                )}
              </Card.Text>
            </Card.Body>
            <Card.Footer className="d-flex gap-3 border-0">
            
            </Card.Footer>
          </Card>
        </Col>

        <Col>
          <Card className="note_card mb-4">
            <Card.Header>Purchase Orders Department</Card.Header>
            <Card.Body className="pb-0">
              <Card.Text>
                <Form.Control
                  {...register("Notes.4.description")}
                  as="textarea"
                  placeholder="Enter Notes..."
                  style={{
                    height: "auto",
                    minHeight: "80px",
                    resize: "none",
                  }}
                  onInput={(e) => {
                    e.target.style.height = "auto"; // Reset height to auto
                    e.target.style.height = `${e.target.scrollHeight}px`; // Set height to scrollHeight to expand
                  }}
                />
                {errors.Notes?.[4]?.description && (
                  <span className="text-danger">
                    {errors.Notes?.[4]?.description.message}
                  </span>
                )}
              </Card.Text>
            </Card.Body>
            <Card.Footer className="d-flex gap-3 border-0"></Card.Footer>
          </Card>
        </Col>
      
      </Row> */}
    </>
  );
}

export default ContactDetailsForm;
